export const pages = {
  locale: (locale: string) => ({
    auth: {
      login: `/${locale}/`,
      resetPassword: `/${locale}/reset-password/`,
      forgotPassword: `/${locale}/forgot-password/`,
      logoff: `/${locale}/logoff`,
    },
    intervention: {
      externalList: `/${locale}/europe-assistance/intervention/list/`,
      b2bList: `/${locale}/b2b/intervention/list/`,
      details: (id: string | number) =>
        `/${locale}/europe-assistance/intervention/${id}`,
    },
    user: {
      details: `/${locale}/user/details`,
      list: `/${locale}/user/list`,
    },
    unauthorized: `/${locale}/unauthorized`,
  }),
};
